import { extractApiError } from '@/shared/utils/handle-api-error'

/** Backend errorCode for a client that already exists (same DPI / NIT). */
export const CLIENT_DUPLICATE_CODE = 'CLIENT_DUPLICATE'

export interface DuplicateClientError {
  /** Human message from the server (includes the existing client code). */
  message: string
  existingCode?: number
  existingId?: string
  existingType?: string
}

/**
 * Returns the duplicate-client info when the error is a CLIENT_DUPLICATE conflict,
 * or null otherwise. Lets the UI offer an actionable path to the existing client
 * instead of a dead-end error. Reusable by any client-creation flow.
 */
export function getDuplicateClientError(error: unknown): DuplicateClientError | null {
  const apiError = extractApiError(error)
  if (apiError?.errorCode !== CLIENT_DUPLICATE_CODE) return null

  const details = (apiError.details ?? {}) as {
    existingCode?: number
    existingId?: string
    existingType?: string
  }
  return {
    message: apiError.message,
    existingCode: details.existingCode,
    existingId: details.existingId,
    existingType: details.existingType
  }
}
